export default __webpack_public_path__ + "static/media/Rabia.3a65ecea.jpeg";